import { render, staticRenderFns } from "./base.vue?vue&type=template&id=6b93330e&scoped=true"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"
import style0 from "./base.vue?vue&type=style&index=0&id=6b93330e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93330e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b93330e')) {
      api.createRecord('6b93330e', component.options)
    } else {
      api.reload('6b93330e', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=6b93330e&scoped=true", function () {
      api.rerender('6b93330e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShopDetail/base.vue"
export default component.exports